import { render } from "./RoteirosmesView.vue?vue&type=template&id=ecb9713e&scoped=true"
import script from "./RoteirosmesView.vue?vue&type=script&lang=js"
export * from "./RoteirosmesView.vue?vue&type=script&lang=js"

import "./RoteirosmesView.vue?vue&type=style&index=0&id=ecb9713e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb9713e"]])

export default __exports__